import { PesquisaService } from './../../service/pesquisa.service';
import { Pesquisa, Opcoes } from './../../model/pesquisa';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-pesquisa',
  templateUrl: './home-pesquisa.component.html',
  styleUrls: ['./home-pesquisa.component.css']
})
export class HomePesquisaComponent implements OnInit {

  public itens: Observable<Pesquisa[]>;
  selectedValue: Opcoes;

  constructor(private service: PesquisaService) { }

  ngOnInit() {
    this.itens = this.service.ultimas();
  }

  getOptionPercent(item: Pesquisa, opcao: Opcoes ) {
    let total = 0;
    item.opcoes.forEach(opt => {
      total += opt.quantidade;
    });
    return (opcao.quantidade * 100) / total;
  }
  votar(item: Pesquisa) {
    this.selectedValue.quantidade++;
    this.service.salvar(item);
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home-pesquisa/home-pesquisa.component.ts